import React, {useState} from "react";
import {useTranslation} from "react-i18next";

import {useMicroZoneInfiniteQuery} from "./query";
import {debounce} from "../../../utils/debounce";

import MDInput from "materialDashboard/components/MDInput";

import Autocomplete from "@mui/material/Autocomplete";
import {getScrollHandler, LoadingAdornment} from "../utils";


const MicroZonesAutocomplete = ({ selectedMicroZones, setSelectedMicroZones, fieldProps={}, microZoneFilter={}, ...props }) => {
    const {t} = useTranslation(["inputs"]);

    const [hasFocus, setHasFocus] = useState(false);
    const [microZoneSearch, setMicroZoneSearch] = useState("");
    const microZoneSearchQuery = useMicroZoneInfiniteQuery({search: microZoneSearch, pageSize:20, order_by: "code", ...microZoneFilter}, hasFocus);

    const microZoneOptions = [
        ...selectedMicroZones,
        ...(microZoneSearchQuery.data?.pages?.flatMap((page) => page.items) ?? []).filter((s) => !selectedMicroZones.find(({id}) => id === s.id)),
    ]

    const handleMicroZoneSearch = debounce((value) => {
        setMicroZoneSearch(value);
    }, 300);

    return <Autocomplete
        multiple
        id="micro-zone-autocomplete"
        options={microZoneOptions}
        isOptionEqualToValue={(option, value) => option.id === value.id}
        getOptionLabel={(microZone) => [microZone.code, microZone.name].filter(x => x).join(" - ")}
        value={selectedMicroZones}
        defaultValue={selectedMicroZones}
        filterOptions={(x) => x}
        loading={microZoneSearch.isFetching}
        onChange={(e, value) => setSelectedMicroZones(value)}
        onClose={() => handleMicroZoneSearch("")}
        onFocus={() => setHasFocus(true)}
        onBlur={() => setHasFocus(false)}
        ListboxProps={{onScroll: getScrollHandler(microZoneSearchQuery)}}
        renderInput={(params) => (
            <MDInput {...params}
                     onChange={(e) => handleMicroZoneSearch(e.target.value)}
                     variant="standard"
                     label={t('microZonesAutocomplete.label')}
                     placeholder={t('microZonesAutocomplete.placeholder')}
                     InputProps={{
                         ...params.InputProps,
                         endAdornment: (<LoadingAdornment infiniteQuery={microZoneSearchQuery} params={params} /> ),
                     }}
                     {...fieldProps}
            />
        )}
        {...props}
    />
}

export default MicroZonesAutocomplete;